import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const ProgressDots = ({ length, currentIndex, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) }, Array.from({ length }, (_, i) => (React.createElement("div", { key: i, className: css(styles.progressDot, i === currentIndex && styles.currentProgressDot) })))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0 5px',
    },
    progressDot: {
        width: 5,
        height: 5,
        backgroundColor: Colors.PrimaryDark,
        borderRadius: 10,
        opacity: 0.5,
    },
    currentProgressDot: {
        opacity: 1,
    },
});
